import React from "react";
import "./Powering.css";
import holoCat from "../../Media/holo-cat.webp";
import meshGradient from "../../Media/mesh-gradient.jpg";

const Powering = () => {
  return (
    <section
      className="powering-section"
      style={{ backgroundImage: `url(${meshGradient})` }}
    >
      <div className="powering-section-content">
        <div className="powering-section-text">
          <div className="powering-section-heading">
            <h1 className="powering-what-next who-we-are-animate">
              Powering What's Next
            </h1>
          </div>
          <div className="powering-section-description">
            <p className="powering-description-text who-we-are-animate">
              We are your partner built for ambition, driven by innovation, and
              trusted across industries to turn ideas into impact.
            </p>
          </div>
        </div>
        <div className="powering-section-image">
          <img
            className="holo-cat"
            src={holoCat}
            alt="Digital innovation illustration representing Althi Solutions"
            loading="eager"
            fetchPriority="high"
          />
        </div>
      </div>
    </section>
  );
};

export default Powering;
